export default __webpack_public_path__ + "static/media/misc-fireplaceA-1920w.bef571d6.png";